"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _I18n = _interopRequireDefault(require("I18n"));

var _TimelineFilterOptions = _interopRequireDefault(require("crm_ui/timeline/helpers/TimelineFilterOptions"));

var _immutable = require("immutable");

var _loggers = require("customer-data-tracking/loggers");

var _TimelineActions = _interopRequireDefault(require("crm_ui/timeline/data/actions/TimelineActions"));

function getTranslatedLabel(eventType) {
  var translatedLabel = '';

  if (eventType.has && eventType.has('name')) {
    translatedLabel = eventType.get('name');
  } else {
    var label = _TimelineFilterOptions.default.TYPE_LABEL_MAP[eventType];

    if (label) {
      translatedLabel = _I18n.default.text(label);
    }
  }

  return translatedLabel;
}

function sortFilterLabels(a, b) {
  var labelA = getTranslatedLabel(a);
  var labelB = getTranslatedLabel(b);

  if (labelA.toLowerCase() < labelB.toLowerCase()) {
    return -1;
  }

  return 1;
}

function getAvailableOptions(objectType) {
  return (0, _immutable.fromJS)(_TimelineFilterOptions.default.ALL[objectType]).reduce(function (map, val, key) {
    return map.set(key, val.sort(sortFilterLabels));
  }, (0, _immutable.Map)());
}

function handleResetFilters(objectType) {
  _loggers.CrmLogger.logRecordInteraction(objectType, {
    action: 'timeline filters cleared'
  });

  _TimelineActions.default.clearFilters(objectType);
}

var _default = {
  getAvailableOptions: getAvailableOptions,
  handleResetFilters: handleResetFilters
};
exports.default = _default;
module.exports = exports.default;